// src/lib/anonymous-user.ts

const ANONYMOUS_USER_ID_KEY = 'anonymous_user_id';

/**
 * Generate a random UUID v4
 */
function generateUserId(): string {
    return crypto.randomUUID ? crypto.randomUUID() :
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
}

/**
 * Get or create anonymous user ID from localStorage
 * Works in browser environment only
 */
export function getAnonymousUserId(): string | null {
    if (typeof window === 'undefined') return null;

    let userId = localStorage.getItem(ANONYMOUS_USER_ID_KEY);

    if (!userId) {
        userId = generateUserId();
        localStorage.setItem(ANONYMOUS_USER_ID_KEY, userId);
    }

    return userId;
}

/**
 * Set anonymous user ID (useful for testing or migration)
 */
export function setAnonymousUserId(userId: string): void {
    if (typeof window === 'undefined') return;
    localStorage.setItem(ANONYMOUS_USER_ID_KEY, userId);
}

/**
 * Clear anonymous user ID
 */
export function clearAnonymousUserId(): void {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(ANONYMOUS_USER_ID_KEY);
}

/**
 * Get user ID - returns anonymous ID if not authenticated
 * This should be used in API calls to identify the user
 */
export function getUserIdForRequest(isAuthenticated: boolean, authUserId?: string): string | null {
    if (isAuthenticated && authUserId) {
        return authUserId;
    }
    return getAnonymousUserId();
}